import { useFlags as useFlagsLD } from 'launchdarkly-react-client-sdk';

export const useFlags = useFlagsLD<{
  acBlock: boolean;
  dcBlockPricing: boolean;
  maintenanceMode: boolean;
  persistentFilters: boolean;
  pricingEngine: boolean;
  solarPricingPolicy: boolean;
  storageModule: boolean;
  storageEngineVersion: string;
  moduleCardRowMenu: boolean;
  taxCredit: boolean;
  pricingPolicyAnnouncement: boolean;
  solarPpuBanner: boolean;
  solarPricingVisualization: boolean;
  energyTerms: boolean;
  storageFilters: boolean;
  solarFilters: boolean;
  marketIntelVisualization: boolean;
  projectSpecificPricingV2: boolean;
  useDomesticContent: boolean;
  enableRooftop: boolean;
  newProjectFlow: boolean;
  /** Includes this offering in the Product Offerings dropdown on company edit pages in Admin (e.g. https://app.dev.anzarenewables.com/admin/companies/edit/274). See SB-1377. */
  solarMarketIntelligenceProductOffering: boolean;
}>;
